import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-mention-div',
  templateUrl: './mention-div.component.html',
  styleUrls: ['./mention-div.component.scss']
})
export class MentionDivComponent implements OnInit {

  constructor() { }
  @Input() comment: string = '';
  @Input() mentionedInfo: any[] = [];

  arrangedUsers: any[] = [];

  uuidPattern = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/g;
  urlPattern = /https?:\/\/[^\s]+/g;

  parts: string[] = [];

  ngOnInit(): void {
    if (!this.mentionedInfo) {
      this.mentionedInfo = [];
    }
    this.secondWay();
  }

  secondWay() {
    const combinedPattern = new RegExp(`${this.uuidPattern.source}|${this.urlPattern.source}`, 'g');
    const partsWithoutSpecials = this.comment.split(combinedPattern);
    const specials = this.comment.match(combinedPattern);

    specials && specials.forEach((item, i) => {
      if (this.uuidPattern.test(item)) {
        let user = this.mentionedInfo.find(u => u.id == item);
        this.arrangedUsers[i] = user ? user : item;
      } else {
        this.arrangedUsers[i] = item; // it's a URL
      }
    });

    this.parts = this.mergeArrays(partsWithoutSpecials, this.arrangedUsers);
  }

  mergeArrays(array1: any[], array2: any[]): any[] {
    const result: any[] = [];
    const length = Math.max(array1.length, array2.length);

    for (let i = 0; i < length; i++) {
      if (i < array1.length) {
        result.push(array1[i]);
      }
      if (i < array2.length) {
        result.push(array2[i]);
      }
    }

    return result;
  }

  isUrl(part: string): boolean {
    return this.urlPattern.test(part);
  }

  getLinkHtml(url: string): string {
    return `<a href="${url}" target="_blank">${url}</a>`;
  }

}
